export default __webpack_public_path__ + "static/media/blue-left.cb1fbe93.svg";